import './utils/set-public-path';
// The styles.min.css is imported just to enable watch mode on DS. This is removed when bundling for prod


import { tg24roomWidget } from '@sky-it-video/video-tg24room-widgets';

import { defineWebComponents } from './utils/web-components-utils';
import DynamicTg24roomMain from './components/tg24room-main/dynamic-tg24room-main';

const webComponentsMap = new Map();
webComponentsMap.set(tg24roomWidget.tag, DynamicTg24roomMain);
defineWebComponents(webComponentsMap);
